import React, { Component } from 'react';
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import {connect} from "react-redux";
import AppLayout from "./components/shared/applayout";
import PropTypes from 'prop-types';

import Notifications from "./components/Notifications";
import ItemList from "./components/ItemList";
import ListMalfunctions from './components/ListMalfunctions';
import Malfunction from './components/Malfunction';
import MalfunctionForm from './components/MalfunctionForm';
import ActionEditForm from './components/ActionEditForm';
import LocationList from'./components/baseinfo/locations/list';
import LocationView from'./components/baseinfo/locations/view';
import LocationEdit from'./components/baseinfo/locations/edit';
import InverterList from'./components/baseinfo/inverters/list';
import InverterNew from'./components/baseinfo/inverters/new';
import InverterView from'./components/baseinfo/inverters/view';
import InverterEdit from'./components/baseinfo/inverters/edit';
import LoggerList from'./components/baseinfo/loggers/list';
import LoggerView from'./components/baseinfo/loggers/view';
import LoggerEdit from'./components/baseinfo/loggers/edit';
import LoggerNew from'./components/baseinfo/loggers/new';
import Login from'./components/shared/login';
import NewWizard from './components/baseinfo/new';
import YearStatus from "./components/YearStatus";
import Auth from "./util/auth";

class App extends Component {
    static propTypes = {
        dispatch: PropTypes.func
    }

    state = {
        loggedIn: false
    }
    componentWillMount = async () => {
        const authInst = Auth.getInstance();
        let loggedIn = false;
        if(authInst._getDecodedToken()){
            this.setState({loggedIn: true});
            loggedIn = true;
        }

        const query = decodeURI(window.location.search.substring(1).replace(/&/g, "\",\"").replace(/=/g, "\":\""));
        if(query.length > 0){
            if(!loggedIn) {
                console.log("notLoggedIn");
                const queryParams = JSON.parse('{"' + query + '"}');
                if (queryParams && queryParams.token) {
                    console.log('processing JWT');
                    if (authInst.processJWT(queryParams.token, this.props.dispatch)) {
                        console.log('it returned true!');
                        window.location = '/';
                    }
                    console.log('it returned false :(');
                }
            }else {
                window.location = '/';
            }
        }
    }

    render() {
        return (
            <BrowserRouter>
                {(this.state.loggedIn) ?

                    <AppLayout>
                        <Switch>
                            <Route path='/' exact component={Notifications} />
                            <Route path='/benchmark'  component={ItemList} />
                            <Route path='/jaaroverzicht'  component={YearStatus} />
                            <Route path='/locaties' exact component={LocationList} />
                            <Route path='/locaties/:id' exact component={LocationView} />
                            <Route path='/locaties/:id/bewerk' exact component={LocationEdit} />
                            <Route path='/loggers' exact component={LoggerList} />
                            <Route path='/loggers/new/:location' exact component={LoggerNew} />
                            <Route path='/loggers/:id' exact component={LoggerView} />
                            <Route path='/loggers/:id/bewerk' exact component={LoggerEdit} />
                            <Route path='/omvormers' exact component={InverterList} />
                            <Route path='/omvormers/new/:location/:logger' exact component={InverterNew} />
                            <Route path='/omvormers/:id' exact component={InverterView} />
                            <Route path='/omvormers/:id/bewerk' exact component={InverterEdit} />
                            <Route path='/wizard' component={NewWizard} />
                            <Route path='/storingen' exact component={ListMalfunctions} />
                            <Route path='/storingen/:id' exact component={Malfunction} />
                            <Route path='/storingen/:id/edit' exact component={MalfunctionForm} />
                            <Route path='/storingen/:id/actions/:actionid' exact component={ActionEditForm} />
                        </Switch>
                    </AppLayout> :
                    <Login />
                }
            </BrowserRouter>
        );

    }
}


const mapStateToProps = state => {
    return {
        dispatch: state.dispatch
    }
};

export default connect(mapStateToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js